document.addEventListener("DOMContentLoaded", function () {
  const tabBtns = document.querySelectorAll(".tab-btn");
  const tabPanels = document.querySelectorAll(".tab-panel");

  tabBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const tabId = btn.dataset.tab;

      tabBtns.forEach((b) => {
        b.classList.remove("active");
        b.setAttribute("aria-selected", "false");
      })

      btn.classList.add("active");
      btn.setAttribute("aria-selected", "true");

      tabPanels.forEach((panel) => {
        panel.classList.remove("active");
        if (panel.dataset.tab === tabId) {
          panel.classList.add("active");
        }
      });
    });
  });

  document.querySelectorAll('.clickable-tag').forEach(function(span) {
    span.style.cursor = 'pointer';
    span.addEventListener('click', function(e) {
      e.preventDefault();
      window.location.href = span.getAttribute('data-url');
    });
  });

  // Trigger read more button to open Description tab

  let toggleList = document.querySelector('.toggle-link');
  if (toggleList) {
    toggleList.addEventListener('click', function (e) {
      e.preventDefault();
      let descAccordion = document.querySelector('accordion-disclosure.accordion[data-label-value="Description"]');
      let descDetails = document.querySelector('details.accordion__disclosure');
      let descContent = document.querySelector('details.accordion__disclosure .accordion__content.prose');
      if (descAccordion) {
        descAccordion.classList.add('is-open');
        descAccordion.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
      if (descDetails && descAccordion && descAccordion.classList.contains('is-open')) {
        descDetails.setAttribute('open', true);
        if (descContent) {
          descContent.style.opacity = "1";
        }
      }
    });
  }

 if (window.location.pathname === "/collections/publications") {
      window.location.href = "/pages/magazines-by-brand";
    }
     if (window.location.pathname === "/collections/exclusives") {
      window.location.href = " /collections/the-shoppe-brands";
    }
     if (window.location.pathname === "/collections/magazines") {
      window.location.href = "/pages/magazines-by-brand";
    }
     if (window.location.pathname === "/collections/all") {
      window.location.href = "/collections/the-shoppe-brands";
    }

});